module.exports = __webpack_public_path__ + "img/117.4.09d13372.png";